import React from 'react';
import Logo from '../img/1x40x40.png'
import './Nav.css';
import { Link } from 'react-router-dom';


function Nav() {
  return (
    <nav className="navbar navbar-dark bg-dark" nav='nav'>
      <Link to='/'>
        <span className="navbar-brand">
          <img id="logoHenry" src={Logo} width="30" height="30" className="d-inline-block align-top" alt="" />
          Feliz Cumple!!!
        </span>
      </Link>
      <Link to='/about'>
        <span class='click'>Click Aquí</span>
      </Link>
    </nav>
  );
};

export default Nav;
